var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.842 3.01003C35.8413 3.80541 35.5248 4.56796 34.962 5.13003L19.618 20.474C19.1536 20.9383 18.7852 21.4896 18.5338 22.0963C18.2825 22.703 18.1531 23.3533 18.1531 24.01C18.1531 24.6667 18.2825 25.317 18.5338 25.9237C18.7852 26.5305 19.1536 27.0817 19.618 27.546L34.942 42.87C35.4885 43.4358 35.7909 44.1936 35.784 44.9802C35.7772 45.7668 35.4617 46.5193 34.9055 47.0755C34.3492 47.6317 33.5968 47.9472 32.8102 47.954C32.0236 47.9609 31.2658 47.6585 30.7 47.112L15.376 31.8C13.3155 29.7355 12.1583 26.9378 12.1583 24.021C12.1583 21.1042 13.3155 18.3066 15.376 16.242L30.72 0.888028C31.1396 0.468196 31.6742 0.182255 32.2564 0.0663869C32.8385 -0.0494813 33.4419 0.00993097 33.9902 0.237106C34.5386 0.464281 35.0072 0.849008 35.3369 1.34261C35.6665 1.8362 35.8423 2.41649 35.842 3.01003Z",
    fill: "#112348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/arrowleft.f2ceec865ae8187086014547f495edcf.svg";
export { ForwardRef as ReactComponent };